// extracted by extract-css-chunks-webpack-plugin
module.exports = {"warning":"#f8d13a","greyLight":"#b5b5b5","checkbox":"InputCheckbox_checkbox-20_cL","indicator":"InputCheckbox_indicator-12HE3","input":"InputCheckbox_input-d5GC-"};